import { playUIClick } from "@/audio/SoundManager";
import { COLORS, type PlayerCustomization } from "./PlayerCustomization";

export class ColorPicker {
  private container = document.getElementById("color-options")!;

  build(current: PlayerCustomization, onChange: (tint: number) => void): void {
    for (const c of COLORS) {
      const btn = document.createElement("button");
      btn.style.background = c.hex;
      btn.title = c.hex;
      if (c.tint === current.color) btn.classList.add("selected");
      btn.addEventListener("click", () => {
        this.container.querySelectorAll("button").forEach((b) => b.classList.remove("selected"));
        btn.classList.add("selected");
        onChange(c.tint);
        playUIClick();
      });
      this.container.appendChild(btn);
    }
  }
}
